import { connect } from 'react-redux';
import { isVideoDialEnabledSelector } from '../../../../../../store/redux/selectors/videoDialEnabledSelector';
import ImageStimOptions from './ImageStimOptions';

export default connect(isVideoDialEnabledSelector)(ImageStimOptions);
